module.exports = __webpack_public_path__ + "img/block-why.6e78bbaf.png";